import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import ghMarketApi from '../../api/ghMarketApi';
import { ProductInterface } from "../../store/gh_market/productsSlice";

const PREFIX = 'gh_market';

const processStrategy = (value: any) => {
  return { ...value };
}

const productsEntity = new schema.Entity(
  'products',
  {},
  { processStrategy }
);

export const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { products: { [key: string]: ProductInterface } }
  >(response.data.products, [productsEntity]);

  return {
    products: normalized.entities?.products || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchProducts = createAsyncThunk(
  `${PREFIX}_products/fetchProducts`,
  async (params: object = {}) => {
    const response = await ghMarketApi.get(`/onesky/products`, { params })
    return normalizeCollection(response);
  }
);
